import { render, staticRenderFns } from "./VgCollapsePanel.vue?vue&type=template&id=9a6a463c&scoped=true&"
import script from "./VgCollapsePanel.vue?vue&type=script&lang=js&"
export * from "./VgCollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./VgCollapsePanel.vue?vue&type=style&index=0&id=9a6a463c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6a463c",
  null
  
)

export default component.exports